const CATS = ["Places to Eat + Drink", "Galleries + Studios", "Specialty Shops + Salons", "Community + Business Services"];

export const RESOURCES = {
  businesses: {
    label: "Businesses",
    primary: "name",
    columns: ["name", "category", "tier", "featured"],
    fields: [
      { key: "name", label: "Name", type: "text", required: true },
      { key: "category", label: "Category", type: "select", options: CATS, required: true },
      { key: "tagline", label: "Tagline", type: "text" },
      { key: "description", label: "Description", type: "textarea" },
      { key: "address", label: "Address", type: "text" },
      { key: "phone", label: "Phone", type: "text" },
      { key: "website", label: "Website", type: "text" },
      { key: "instagram", label: "Instagram", type: "text" },
      { key: "hours", label: "Hours", type: "text" },
      { key: "image", label: "Image URL", type: "text" },
      { key: "tags", label: "Tags (comma separated)", type: "csv" },
      { key: "tier", label: "Tier", type: "select", options: ["free", "pro", "premium"] },
      { key: "featured", label: "Featured", type: "bool" },
      { key: "status", label: "Status", type: "select", options: ["open", "closed"] },
    ],
  },
  events: {
    label: "Events",
    primary: "title",
    columns: ["title", "date", "category", "featured"],
    fields: [
      { key: "title", label: "Title", type: "text", required: true },
      { key: "description", label: "Description", type: "textarea" },
      { key: "date", label: "Date (YYYY-MM-DD)", type: "text" },
      { key: "time", label: "Time", type: "text" },
      { key: "venue", label: "Venue", type: "text" },
      { key: "address", label: "Address", type: "text" },
      { key: "category", label: "Category", type: "text" },
      { key: "image", label: "Image URL", type: "text" },
      { key: "price", label: "Price", type: "text" },
      { key: "featured", label: "Featured", type: "bool" },
    ],
  },
  offers: {
    label: "Offers",
    primary: "title",
    columns: ["title", "business_name", "discount"],
    fields: [
      { key: "title", label: "Title", type: "text", required: true },
      { key: "business_name", label: "Business", type: "text" },
      { key: "description", label: "Description", type: "textarea" },
      { key: "discount", label: "Discount", type: "text" },
      { key: "valid_until", label: "Valid Until", type: "text" },
      { key: "image", label: "Image URL", type: "text" },
      { key: "category", label: "Category", type: "text" },
    ],
  },
  promotions: {
    label: "Promotions",
    primary: "title",
    columns: ["title", "day", "active"],
    fields: [
      { key: "title", label: "Title", type: "text", required: true },
      { key: "subtitle", label: "Subtitle", type: "text" },
      { key: "day", label: "Day / Frequency", type: "text" },
      { key: "description", label: "Description", type: "textarea" },
      { key: "image", label: "Image URL", type: "text" },
      { key: "participating", label: "Participating (comma separated)", type: "csv" },
      { key: "active", label: "Active", type: "bool" },
    ],
  },
  tours: {
    label: "Tours",
    primary: "title",
    columns: ["title", "operator", "price"],
    fields: [
      { key: "title", label: "Title", type: "text", required: true },
      { key: "operator", label: "Operator", type: "text" },
      { key: "description", label: "Description", type: "textarea" },
      { key: "duration", label: "Duration", type: "text" },
      { key: "price", label: "Price", type: "text" },
      { key: "image", label: "Image URL", type: "text" },
      { key: "booking_url", label: "Booking URL", type: "text" },
      { key: "category", label: "Category", type: "text" },
    ],
  },
};
